import { NumberInput } from '@mantine/core';
import { IFormInputSpecNumberOfMeasurements } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a number of measurements input.
 */
export default function NumberOfMeasurementsInputPreview({ spec }: { spec: IFormInputSpecNumberOfMeasurements }) {
  return <NumberInput required={spec.required} readOnly size="sm" hideControls />;
}
